/* Supabase client — used ONLY for auth (email verification, password, sessions).
   Every other request goes to our own API with the Supabase access token as Bearer.
   Configure with VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.

   If those aren't set (e.g. pure local dev with AUTH_ALLOW_DEV), we export a stub so the
   app still loads and the dev-token path works. */
import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

function stub() {
  const noSession = async () => ({ data: { session: null }, error: null });
  const notConfigured = async () => ({ data: null, error: new Error("Supabase auth is not configured") });
  return {
    auth: {
      getSession: noSession,
      onAuthStateChange: () => ({ data: { subscription: { unsubscribe() {} } } }),
      signInWithPassword: notConfigured,
      signUp: notConfigured,
      signOut: async () => ({ error: null }),
    },
  };
}

export const supabaseEnabled = Boolean(url && anon);
export const supabase = supabaseEnabled
  ? createClient(url, anon, { auth: { persistSession: true, autoRefreshToken: true } })
  : stub();
